import { __extends } from 'tslib';
import * as React from 'react';

var TooltipInnerBody = (function (_super) {
    __extends(TooltipInnerBody, _super);
    function TooltipInnerBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipInnerBody.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.content !== nextProps.content;
    };
    TooltipInnerBody.prototype.render = function () {
        return this.props.content;
    };
    return TooltipInnerBody;
}(React.Component));

export { TooltipInnerBody as default };
//# sourceMappingURL=TooltipInnerBody.js.map
